import styled from "styled-components";
import { colors, params } from "../../../theme/Params";
import { device } from "../utils";

export const ScNavBar = styled.div`
  background-color: white;
  border-radius: ${params.containerBlockRadius};
  box-shadow: ${params.boxShadow};

  * > .nav-bar-container {
    display: flex;
    justify-content: space-between;
  }

  > div {
    padding: 16px 32px;
  }

  .navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;

    & > .image-filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 48px;

      & > input[type="range"] {
        margin-left: 16px;
        width: 300px;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    a {
      color: ${colors.grey95};
      text-decoration: none;

      &:hover {
        opacity: 0.7;
      }

      i {
        height: 16px;
        width: 18px;
        display: inline-block;
        margin-right: 15px;
      }
    }
  }

  .user-control {
    display: flex;
    align-items: center;
    text-align: right;

    span {
      margin-right: 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: ${colors.grey50};

      @media (${device.mobileS}) {
        display: none;
      }
    }

    button {
      height: 38px;
      width: 38px;
      border-radius: 40px;
      padding: 6px 7px;
      border: none;
    }
  }

  .break {
    flex-basis: 100%;
    width: 0;
  }
`;
